// ========== LOGO 3D ==========
import * as THREE from "three";
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

export function initLogo3D() {
  const container = document.getElementById("logo3d");
  if (!container) return;

  const modelUrl = container.dataset.model;

  const width = container.offsetWidth || 300;
  const height = container.offsetHeight || 300;

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
  camera.position.set(0, 0, 90);
  camera.lookAt(0, 0, 0);

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(width, height);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.5;
  container.appendChild(renderer.domElement);

  // Environment para reflejos
  const pmremGenerator = new THREE.PMREMGenerator(renderer);
  pmremGenerator.compileEquirectangularShader();
  const envMap = pmremGenerator.fromScene(new RoomEnvironment()).texture;
  scene.environment = envMap;

  // Luces de apoyo
  const light1 = new THREE.DirectionalLight(0xffffff, 1);
  light1.position.set(5, 5, 5);
  scene.add(light1);

  scene.add(new THREE.AmbientLight(0xffffff, 0.5));

  // Variables para el movimiento del mouse
  let targetRotationX = 0;
  let targetRotationY = 0;
  let currentRotationX = 0;
  let currentRotationY = 0;
  let baseRotationX = 0;
  let baseRotationY = 0;

  let logo;
  const loader = new GLTFLoader();

  loader.load(modelUrl, (gltf) => {
    logo = gltf.scene;

    // Material cromado/plateado - más visible
    logo.traverse((child) => {
      if (child.isMesh) {
        child.material = new THREE.MeshStandardMaterial({
          color: 0x111111, // Negro/gris muy oscuro
          metalness: 0.9,
          roughness: 0.1, // Muy brillante
          envMap: envMap,
          envMapIntensity: 2, // Reflejos fuertes
        });
      }
    });

    // Centrar
    const box = new THREE.Box3().setFromObject(logo);
    const center = box.getCenter(new THREE.Vector3());
    logo.position.sub(center);

    logo.position.x = 0;
    logo.position.y = 0;

    // Escalar
    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);
    logo.scale.setScalar(100 / maxDim);

    // Rotar para ver de frente
    logo.rotation.x = -Math.PI / 2;
    logo.rotation.y = Math.PI;

    logo.scale.x *= -1;

    baseRotationX = logo.rotation.x;
    baseRotationY = logo.rotation.y;

    scene.add(logo);
  });

  // Movimiento con el mouse
  document.addEventListener("mousemove", (e) => {
    const x = (e.clientX / window.innerWidth) * 2 - 1;
    const y = (e.clientY / window.innerHeight) * 2 - 1;

    targetRotationX = y * 0.3;
    targetRotationY = x * 0.3;
  });

  function animate() {
    requestAnimationFrame(animate);

    if (logo) {
      currentRotationX += (targetRotationX - currentRotationX) * 0.05;
      currentRotationY += (targetRotationY - currentRotationY) * 0.05;

      logo.rotation.x = baseRotationX + currentRotationX;
      logo.rotation.z = currentRotationY;
    }

    renderer.render(scene, camera);
  }
  animate();

  window.addEventListener("resize", () => {
    const w = container.offsetWidth;
    const h = container.offsetHeight;
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h);
  });
}
